import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import useOnboardingSx from '../../hooks/useOnboardingSx';

export default function LogoUpload({ fileName, onSelectFile }) {
  const sx = useOnboardingSx();

  return (
    <Paper
      variant="outlined"
      sx={{
        ...sx.logoUploadBox,
        ...(fileName ? sx.logoUploadBoxActive : {}),
        transition: 'border-color 0.2s',
      }}
    >
      <CloudUploadIcon sx={sx.uploadIcon} />
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {fileName ? `Selected: ${fileName}` : 'PNG or JPG, recommended 256×256 px'}
      </Typography>
      <Button variant="contained" component="label" size="small" sx={{ ...sx.continueButton, mt: 1 }}>
        {fileName ? 'Change logo' : 'Upload logo'}
        <input type="file" hidden accept="image/png,image/jpeg,image/webp" onChange={onSelectFile} />
      </Button>
    </Paper>
  );
}
